<template>
  <div
    id="mobileprofile"
    class="mobile-card-select d-sm-none profile-account profile-info show"
  >
    <div class="select-card p-0 mb-0">
      <div class="checkout-card px-0 text-center">
        <div class="back-cart">
          <router-link :to="{ name: 'profile' }" class="back-account">
            <img src="/images/svg/global/left_arrow.svg" alt="" />
          </router-link>
        </div>
        <h4 class="pl-0">{{ _T('Edit profile') }}</h4>
        <div class="media-user text-center">
          <div class="change-photo">
            <image-field
              class="update_img_0 icon-change"
              @setImageData="setImageData"
              :avatar_url="web_user.avatar"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="select-card personal-info">
      <div class="info-title">
        <h6>{{ _T('Personal Information') }}</h6>
      </div>
    </div>
    <div class="change-personal">
      <h6>
        {{ _T('Full Name') }}
        <a @click="$bvModal.show('change-profile')">{{ _T('Change') }}</a>
      </h6>
      <span>{{ web_user.name }}</span>
    </div>
    <div class="change-personal">
      <h6>
        {{ _T('Email') }}
        <a @click="$bvModal.show('change-email')">{{ _T('Change') }}</a>
      </h6>
      <span>{{ web_user.email }}</span>
    </div>
    <div class="change-personal mb-0">
      <h6>
        {{ _T('Phone Number') }}
        <a @click="$bvModal.show('change-number')">
          {{ _T('Change') }}
        </a>
      </h6>
      <span>{{ web_user.phone_number }}</span>
    </div>
    <div class="select-card personal-info mb-0">
      <div class="info-title">
        <h6>{{ _T('Security') }}</h6>
      </div>
    </div>
    <div class="change-personal">
      <h6>
        {{ _T('Password') }}
        <a @click="$bvModal.show('change-password')">
          {{ _T('Change') }}
        </a>
      </h6>
      <span>********</span>
    </div>

    <change-name-and-image />
    <change-number />
    <change-password />
    <change-email />
    <verify-email />
    <verify-number />
    <check-email />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { handleApiErrors } from '@/utils/main_utils.js'

import ChangeNameAndImage from '@/components/Modals/Profile/ChangeNameAndImage'
import ChangeEmail from '@/components/Modals/Profile/ChangeEmail'
import ChangePassword from '@/components/Modals/Profile/ChangePassword'
import ChangeNumber from '@/components/Modals/Profile/ChangeNumber'
import CheckEmail from '@/components/Modals/Profile/CheckEmail'
import VerifyEmail from '@/components/Modals/Profile/VerifyEmail'
import VerifyNumber from '@/components/Modals/Profile/VerifyNumber'
import ImageField from '@/components/Elements/ImageField'

export default {
  name: 'MobilePersonalInformation',
  data: () => ({
    userAvatarImage: undefined,
    process: 'change-avatar',
  }),
  computed: {
    ...mapGetters([
      'is_customer_logged_in',
      '_T',
      'web_user',
      'processInProgress',
    ]),
    getAvatarData() {
      if (this.userAvatarImage === undefined) {
        return this.web_user.avatar
      } else {
        return this.userAvatarImage
      }
    },
  },
  methods: {
    setImageData(data) {
      this.userAvatarImage = data
      this.changeNameAndImage()
    },
    changeNameAndImage() {
      if (!this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        this.$store
          .dispatch('update_user_avatar_name', {
            avatar: this.getAvatarData,
            name: this.web_user.name,
          })
          .then(resp => {
            let responseData = resp.data
            if (responseData.status === 'form_errors') {
              let errors = handleApiErrors(responseData.form_errors)
              this.$store.dispatch('showNotification', {
                text: this._T(errors),
                status: 'error',
              })
            } else {
              this.$store.dispatch('showNotification', {
                text: this._T('Record updated succesfully'),
                status: 'success',
              })
              this.$bvModal.hide(this.modalId)
            }
          })
          .catch(() => {
            this.$store.dispatch('showNotification', {
              text: this._T('Your request was not successfull'),
              status: 'error',
            })
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
  },
  components: {
    ChangeNameAndImage,
    ChangeEmail,
    ChangePassword,
    ChangeNumber,
    CheckEmail,
    VerifyEmail,
    VerifyNumber,
    ImageField,
  },
}
</script>

<style lang="scss" scoped>
#mobileprofile {
  display: none;

  &.show {
    display: block;
  }
}
.profile-info {
  background-color: $light-border;
  height: calc(100vh - #{$px1}) !important;

  .select-card {
    + .select-card {
      border-top: none !important;
    }
    .checkout-card {
      text-align: center;
      padding: $px18 $px20;
      background-color: white;
      border-bottom: $px12 solid $light-border;

      h4 {
        padding: $px10 $px20 $px10 $px50;
        border-bottom: $px1 solid $light-border;
        font-weight: 600;

        .skip-this {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $light-font;
          position: absolute;
          right: $px2;
          top: $px4;
        }
      }

      .back-cart {
        position: absolute;
        top: $px18;
        left: $px20;
        z-index: 1;
      }
    }
  }

  .personal-info {
    padding: $px20 $px20 $px6 !important;

    .info-title {
      h6 {
        margin-bottom: 0;
      }
    }
  }

  .change-personal {
    background-color: $white;
    padding: $px14 $px20;
    margin-bottom: $px12;

    h6 {
      font-weight: 600;
      font-size: $px13;
      line-height: $px16;
      letter-spacing: 0.02em;

      a {
        float: right;
      }
    }

    span {
      line-height: $px17;
      letter-spacing: 0.02em;
      color: $light-font;
    }
  }
}

.profile-account {
  .iti--allow-dropdown {
    .iti__country-list {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      border-radius: $px10 $px10 0 0;
    }

    .iti__dial-code {
      float: right;
    }

    .iti__country {
      padding: $px10;
    }
  }

  .select-card {
    .btn-fix {
      position: fixed;
      padding: $px20;
      left: 0;
      margin: 0 auto;
      bottom: 0;
      right: 0;
      background-color: $white;
      z-index: 1;
    }
  }
}
.profile-info {
  background-color: $light-border;
  height: calc(100vh - #{$px1}) !important;

  .select-card {
    + .select-card {
      border-top: none !important;
    }
  }

  .personal-info {
    padding: $px20 $px20 $px6 !important;

    .info-title {
      h6 {
        margin-bottom: 0;
      }
    }
  }

  .change-personal {
    background-color: $white;
    padding: $px14 $px20;
    margin-bottom: $px12;

    h6 {
      font-weight: 600;
      font-size: $px13;
      line-height: $px16;
      letter-spacing: 0.02em;

      a {
        float: right;
      }
    }

    span {
      line-height: $px17;
      letter-spacing: 0.02em;
      color: $light-font;
    }
  }
}

.media-user {
  padding: $px16;
  align-items: center;

  img {
    padding: $px4;
    border: $px1 solid $light-border;
    border-radius: 100%;
    width: $px74;
    height: $px74;
  }

  .media-body {
    padding-left: $px12;

    h5 {
      font-weight: 600;
      font-size: $px16;
      color: $black;
      margin-bottom: $px3;
    }

    span {
      font-size: $px13;
      line-height: $px16;
      display: block;
      letter-spacing: 0.02em;
      color: $light-font;
      margin-bottom: $px6;
    }

    a {
      font-weight: 600;
      font-size: $px13;
      line-height: $px16;
    }
  }

  &.text-center {
    img {
      width: $px82;
      height: $px82;
    }

    .change-photo {
      position: relative;

      a {
        &.icon-change {
          width: $px30;
          height: $px30;
          background-color: $color-primary;
          display: flex;
          align-items: center;
          justify-content: center;
          border: $px1 solid $white;
          border-radius: 100%;
          position: absolute;
          right: 40%;
          bottom: 0;

          img {
            padding: 0;
            border: none;
            width: auto;
            height: auto;
          }
        }
      }

      input {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: $px28;
        opacity: 0;
        bottom: 0;
        cursor: pointer;
      }
    }
  }
}
</style>
